export namespace ResetPasswordSetUserPasswordNamespace {
  export interface IN {
    password: string;
    token: string;
    //recaptchaToken: string;
  }

  export class OUT {
    requestKey: string = '';

    // init(input: ResetPasswordSetUserPasswordApiNamespace.OUT) {
    //   // this.requestKey = input.recoverPasswordKey;

    //   return this;
    // }
  }
}
